export const ADD_FRAME_SIZE_SUCCESS = 'ADD_FRAME_SIZE_SUCCESS';
export const LIST_ALL_FRAME_SIZES_SUCCESS = 'LIST_ALL_FRAME_SIZES_REQUEST_SUCCESS';
export const UPDATE_FRAME_SIZE_SUCCESS = 'UPDATE_FRAME_SIZE_SUCCESS';
export const LIST_ALL_FRAME_SIZES_REQUEST = 'LIST_ALL_FRAME_SIZES_REQUEST';
export const LIST_ALL_FRAME_SIZES_FAILURE = 'LIST_ALL_FRAME_SIZES_FAILURE';
export const DELETE_FRAME_SIZE_SUCCESS = 'DELETE_FRAME_SIZE_SUCCESS';
export const CREATE_FRAME_SIZE_SUCCESS = 'CREATE_FRAME_SIZE_SUCCESS';
